<template>
<div>
  <div class="p-3 border-top copyright">
    <b-row>
      <b-col sm="8">
        <span class="text-muted">
        &copy; iAMconnected <span v-text="date"></span>
        <small> - V{{ $store.getters.appVersion }}<br />
        <small>{{ $store.getters.serverDate }}</small></small>
        </span>
        </b-col>
        <b-col>
        <b-button v-b-modal.modal-1 align-middle >Lost? Click me!</b-button>
          <b-modal class="modal-xl" id="modal-1" title="Website Tour">
            <div class="embed-responsive embed-responsive-16by9">
              <iframe width="560" height="315" src="https://www.youtube.com/embed/ZqUaBS8_bgE" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>
            </div>
        </b-modal>
      </b-col>
    </b-row>
  </div>
</div>
</template>

<script>
export default {
  name: 'PageFooter',
  data() {
   return {
   }
  },
  props: {
  },
  computed: {
   date(){
    return new Date().getFullYear();
   },
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
  .copyright {
    line-height: .9rem;
  }


  .modal-xl {
	width: 1000px !important;
  margin: auto;
  }


</style>
